import { render } from "./ASymphonyOfBrilliance.vue?vue&type=template&id=25649c88&scoped=true"
import script from "./ASymphonyOfBrilliance.vue?vue&type=script&lang=js"
export * from "./ASymphonyOfBrilliance.vue?vue&type=script&lang=js"

import "./ASymphonyOfBrilliance.vue?vue&type=style&index=0&id=25649c88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25649c88"]])

export default __exports__